const TableBody = ({ children, className, ...rest }) => {
  return (
    <div className={`tableBody ${className}`} {...rest}>
      {children}
    </div>
  );
};

export default TableBody;
